<template>
  <div :class="{ 'sticked': isSticked }" id="sticky-header">
    <div class="driver-id d-flex align-items-center gap-1">

      <div class="driver-picture">
        <img v-if="missionInfos.driver_data.driver_tag_url" :src="missionInfos.driver_data.driver_tag_url" class="logo">
        <DriverDefaultPictureSvg v-else />
      </div>
      <div>
        <div class="fw-bold fs-7">
          {{ $t('missions_infos.driver_name.title') }} {{ missionInfos.driver_data.name.value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import DriverDefaultPictureSvg from '@images/DriverDefaultPictureSvg.vue';

  export default {
    name: 'StickyHeader',
    props: {
      missionInfos: Object
    },
    components: {
      DriverDefaultPictureSvg
    },
    data() {
      return {
        isSticked: false
      };
    },
    mounted() {
      this.toggle();
      window.addEventListener('scroll', this.toggle);
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.toggle);
    },
    methods: {
      toggle() {
        const topContent = document.querySelector('.top-content');
        if (!topContent) {
          return
        };

        const offsetTop = topContent.offsetTop;
        const topOfWindow = window.scrollY;

        this.isSticked = offsetTop <= topOfWindow - 30;
      }
    }
  };
</script>

<style scoped>
  .sticked {
    position: sticky;
    top: 0;
    z-index: 100;
  }

  #sticky-header {
    position: fixed;
    z-index: 100;
    width: 100%;
    top: -100%;
    -webkit-transition: all 0.5s ease;
    -moz-transition: all 0.5s ease;
    transition: all 0.5s ease;
    background-color: white;
    box-shadow: 0 0 8px 0 rgba(137, 137, 137, 0.25), 0 0 5px 1px rgba(137, 137, 137, 0.2);
    padding: 0.6rem 0.9rem;
    line-height: 16px;
    display: flex;
  }

  #sticky-header.sticked {
    top: 0;
    gap: 1rem;
  }

  #sticky-header .driver-id .driver-picture {
    width: 60px;
    height: 40px;
  }
</style>
